/**
 * kosha.js — 校舎一覧のスクロールスナップ型スライダー。
 * JS が無効でも横スクロールで全カードを閲覧できる。
 */
(function () {
  'use strict';

  function initSlider(root) {
    var viewport = root.querySelector('.p-kosha-slider__viewport');
    var track = root.querySelector('.p-kosha-slider__track');
    var items = Array.from(root.querySelectorAll('.facility_item'));
    var controls = root.querySelector('.p-kosha-slider__controls');
    var prev = root.querySelector('.p-kosha-slider__arrow--prev');
    var next = root.querySelector('.p-kosha-slider__arrow--next');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var frame = 0;

    if (!viewport || !track || items.length === 0 || !controls || !prev || !next) return;

    controls.hidden = false;

    function itemLeft(index) {
      return items[index].offsetLeft - track.offsetLeft
        - ((viewport.clientWidth - items[index].offsetWidth) / 2);
    }

    function update(index) {
      current = Math.max(0, Math.min(items.length - 1, index));
      prev.disabled = current === 0;
      next.disabled = current === items.length - 1;
    }

    function goTo(index) {
      var target = Math.max(0, Math.min(items.length - 1, index));
      viewport.scrollTo({
        left: itemLeft(target),
        behavior: reduced.matches ? 'auto' : 'smooth'
      });
      update(target);
    }

    prev.addEventListener('click', function () { goTo(current - 1); });
    next.addEventListener('click', function () { goTo(current + 1); });
    viewport.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var closest = 0;
        var distance = Infinity;
        items.forEach(function (_item, index) {
          var candidate = Math.abs(viewport.scrollLeft - itemLeft(index));
          if (candidate < distance) {
            distance = candidate;
            closest = index;
          }
        });
        update(closest);
      });
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(current); });
    update(0);
  }

  function init() {
    document.querySelectorAll('.js-kosha-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
